const FREE = 'free';
const ALPHA = 'alpha';
const ALPHA10 = 'alpha10';
const ALPHA365 = 'alpha365';
const BETA = 'beta';
const BETA18 = 'beta18';
const BETA365 = 'beta365';
const GAMMA = 'gamma';
const GAMMA30 = 'gamma30';
const GAMMA365 = 'gamma365';
const GAMMA32 = 'gamma32';
const GAMMALIMITED365 = 'gammalimited365';
const PRO60 = 'pro60';
const PRO495 = 'pro495';
const PRO600 = 'pro600';
const LINK_FREE = 'link_free';
const LINK9 = 'link_9';
const LINK90 = 'link_90';

export const PLANS = {
  FREE,
  ALPHA,
  ALPHA10,
  ALPHA365,
  BETA,
  BETA18,
  BETA365,
  GAMMA,
  GAMMA30,
  GAMMA32,
  GAMMA365,
  GAMMALIMITED365,
  PRO60,
  PRO495,
  PRO600,
  LINK_FREE,
  LINK9,
  LINK90,
};

export const CONSUMER_NAME = {
  [FREE]: 'Free',
  [ALPHA]: 'Alpha',
  [BETA]: 'Beta',
  [GAMMA]: 'Gamma',
  [ALPHA10]: 'Alpha',
  [BETA18]: 'Beta',
  [GAMMA30]: 'Gamma',
  [GAMMA32]: 'Gamma',
  [ALPHA365]: 'Alpha Annual',
  [BETA365]: 'Beta Annual',
  [GAMMA365]: 'Gamma Annual',
  [GAMMALIMITED365]: 'Gamma Annual',
  [PRO60]: 'Pro',
  [PRO495]: 'Pro Annual',
  [PRO600]: 'Pro Annual',
  [LINK_FREE]: 'Wavve Link Free',
  [LINK9]: 'Wavve Link',
  [LINK90]: 'Wavve Link Annual',
};

export const CONSUMER_SHORT_NAME = {
  [FREE]: 'Free',
  [ALPHA]: 'Alpha',
  [BETA]: 'Beta',
  [GAMMA]: 'Gamma',
  [ALPHA10]: 'Alpha',
  [BETA18]: 'Beta',
  [GAMMA30]: 'Gamma',
  [GAMMA32]: 'Gamma',
  [ALPHA365]: 'Alpha',
  [BETA365]: 'Beta',
  [GAMMA365]: 'Gamma',
  [GAMMALIMITED365]: 'Gamma',
  [PRO60]: 'Pro',
  [PRO495]: 'Pro',
  [PRO600]: 'Pro',
  [LINK_FREE]: 'Wavve Link Free',
  [LINK9]: 'Wavve Link',
  [LINK90]: 'Wavve Link',
};

export const CONSUMER_FULL_NAME = {
  [FREE]: 'Wavve Video Free',
  [ALPHA]: 'Wavve Video Alpha',
  [BETA]: 'Wavve Video Beta',
  [GAMMA]: 'Wavve Video Gamma',
  [ALPHA10]: 'Wavve Video Alpha',
  [BETA18]: 'Wavve Video Beta',
  [GAMMA30]: 'Wavve Video Gamma',
  [GAMMA32]: 'Wavve Video Gamma',
  [ALPHA365]: 'Wavve Video Alpha Annual',
  [BETA365]: 'Wavve Video Beta Annual',
  [GAMMA365]: 'Wavve Video Gamma Annual',
  [GAMMALIMITED365]: 'Wavve Video Gamma Annual',
  [PRO60]: 'Wavve Video Pro',
  [PRO495]: 'Wavve Video Pro Annual',
  [PRO600]: 'Wavve Video Pro Annual',
  [LINK_FREE]: 'Wavve Link Free',
  [LINK9]: 'Wavve Link Premium',
  [LINK90]: 'Wavve Link Premium Annual',
};

export const PLAN_MONTHLY_COST = {
  [FREE]: 0,
  [ALPHA]: 7,
  [BETA]: 12,
  [GAMMA]: 18,
  [ALPHA10]: 10,
  [BETA18]: 18,
  [GAMMA30]: 30,
  [GAMMA32]: 32,
  [ALPHA365]: 8,
  [BETA365]: 13,
  [GAMMA365]: 21,
  [GAMMALIMITED365]: 22,
  [PRO60]: 60,
  [PRO495]: 41.25,
  [PRO600]: 50,
  [LINK_FREE]: 0,
  [LINK9]: 9,
  [LINK90]: 7.5,
};

export const PLAN_ANNUAL_COST = Object.keys(PLANS).reduce((costs, PLAN) => {
  const plan = PLANS[PLAN];
  costs[plan] = PLAN_MONTHLY_COST[plan] * 12;
  return costs;
}, {});

export const PAID_PLANS = [
  ALPHA,
  ALPHA10,
  ALPHA365,
  BETA,
  BETA18,
  BETA365,
  GAMMA,
  GAMMA30,
  GAMMA365,
  GAMMA32,
  GAMMALIMITED365,
  PRO60,
  PRO495,
  PRO600,
  LINK9,
  LINK90,
];
export const UNLIMITED_PLANS = [GAMMA, GAMMA30, GAMMA365, PRO60, PRO495];
export const ANNUAL_PLANS = [ALPHA365, BETA365, GAMMA365, GAMMALIMITED365, PRO495, PRO600, LINK90];
export const MONTHLY_PLANS = [ALPHA, ALPHA10, BETA, BETA18, GAMMA, GAMMA30, GAMMA32, PRO60, LINK9];
export const UNLIMITED_DESIGNS_PLANS = [PRO60, PRO495, PRO600];
export const WAVVE_LINK_PLANS = [LINK_FREE, LINK9, LINK90];
export const BUYABLE_PLANS = [ALPHA10, ALPHA365, BETA18, BETA365, GAMMA32, GAMMALIMITED365, LINK9, LINK90];

export const PLAN_MONTHLY_ALLOWANCE = {
  [FREE]: 1 * 60,
  [ALPHA]: 10 * 60,
  [BETA]: 30 * 60,
  [GAMMA]: Infinity,
  [ALPHA10]: 10 * 60,
  [BETA18]: 30 * 60,
  [GAMMA30]: Infinity,
  [GAMMA32]: 5 * 60 * 60,
  [ALPHA365]: 10 * 60,
  [BETA365]: 30 * 60,
  [GAMMA365]: Infinity,
  [GAMMALIMITED365]: 5 * 60 * 60,
  [PRO60]: Infinity,
  [PRO495]: Infinity,
  [PRO600]: Infinity,
  default: null,
};

export const PLAN_ROLLOVER = Object.keys(PLANS).reduce((rollover, PLAN) => {
  const plan = PLANS[PLAN];
  if (plan === PLANS.FREE) {
    // no rollover on free
    rollover[plan] = 0;
  } else if (PLAN_MONTHLY_ALLOWANCE[plan]) {
    // 2x on paid plans
    rollover[plan] = PLAN_MONTHLY_ALLOWANCE[plan] * 2;
  } else {
    // unlimited
    rollover[plan] = PLAN_MONTHLY_ALLOWANCE[plan];
  }
  return rollover;
}, {});

export const PLAN_INTERVAL = {
  [FREE]: 'month',
  [ALPHA]: 'month',
  [BETA]: 'month',
  [GAMMA]: 'month',
  [ALPHA10]: 'month',
  [BETA18]: 'month',
  [GAMMA30]: 'month',
  [GAMMA32]: 'month',
  [ALPHA365]: 'year',
  [BETA365]: 'year',
  [GAMMA365]: 'year',
  [GAMMALIMITED365]: 'year',
  [PRO60]: 'month',
  [PRO495]: 'year',
  [PRO600]: 'year',
  [LINK_FREE]: 'month',
  [LINK9]: 'month',
  [LINK90]: 'year',
  default: 'month',
};

export const PLAN_MAX_LENGTH = {
  [FREE]: 60,
  [ALPHA]: 10 * 60,
  [BETA]: 30 * 60,
  [GAMMA]: 60 * 60,
  [ALPHA10]: 10 * 60,
  [ALPHA365]: 10 * 60,
  [BETA18]: 30 * 60,
  [BETA365]: 30 * 60,
  [GAMMA30]: 48 * 60,
  [GAMMA32]: 48 * 60,
  [GAMMA365]: 48 * 60,
  [GAMMALIMITED365]: 48 * 60,
  [PRO60]: 60 * 60,
  [PRO495]: 60 * 60,
  [PRO600]: 60 * 60,
  default: 48 * 60,
};

export const PLAN_SAVINGS = {
  [PLANS.ALPHA10]: '20%',
  [PLANS.ALPHA365]: '20%',
  [PLANS.BETA18]: '25%',
  [PLANS.BETA365]: '25%',
  [PLANS.GAMMA32]: '30%',
  [PLANS.GAMMALIMITED365]: '30%',
  [PLANS.LINK90]: '20%',
};

export const PLAN_DOLLAR_SAVINGS = {
  [PLANS.ALPHA365]: 36,
  [PLANS.BETA365]: 60,
  [PLANS.GAMMALIMITED365]: 120,
  [PLANS.LINK90]: 18,
};

export default {
  PLANS,
  CONSUMER_NAME,
  PAID_PLANS,
  UNLIMITED_PLANS,
  UNLIMITED_DESIGNS_PLANS,
  WAVVE_LINK_PLANS,
  ANNUAL_PLANS,
  MONTHLY_PLANS,
  PLAN_MONTHLY_ALLOWANCE,
  PLAN_INTERVAL,
  PLAN_MAX_LENGTH,
  PLAN_DOLLAR_SAVINGS,
  PLAN_SAVINGS,
};
